<template>
  <div class="container">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <!-- <div class="header__fixed__left_sp"></div> -->
          <div style="width:100%;" class="header__fixed__center_sp">
            <div v-for="(item,index) in order_title" @click="selectOrderStatus(item)" :class="order_title_status==item.status?'head_title head_title_active':'head_title head_title_unactive'">{{item.name}}</div>
          </div>
          <!-- <div class="header__fixed__right_sp"></div> -->
        </div>
      </div>
    </div>

    <div v-show="loaded" class="order_list">
      <div v-show="orderList.length>0&&loaded==true">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" >
          <div v-for="(item,index) in orderList" :key="index" @click="showOrderDetail(item)" class="order_list_block">
            <div class="title">
              订单号：{{item.order_no}}
              <div :class="[{'title_arrowUnuse':item.book_status==1},'title_status']">{{status[item.book_status]}}</div>
            </div>
            <div class="cont">
              <div :class="[{'cont_stadium_nameUnuse':item.book_status==1},'cont_stadium_name']">{{item.stadium_name}}</div>
              <div class="cont_date">
                {{item.book_date}}&nbsp;&nbsp;{{item.week}}&nbsp;&nbsp;{{item.time}}&nbsp;&nbsp;
                <label>{{item.service_name}}</label>
              </div>
              <div class="cont_num">人数：{{item.num}}</div>
            </div>
            <img v-if="item.type ==3" class="logo_yoga" src="../../assets/images/base/falogo.png" />
            <img v-else class="logo_fit" src="../../assets/images/base/fblogo.png" />
          </div>
        </van-list>
      </div>



      <div v-show="orderList.length==0&&loaded==true" class="order_list_empty">
        <img src="../../assets/images/FLVersion/fl_noorder.png" />
        <div class="order_list_empty1">暂无订单</div>
        <div @click="toorder()" class="order_list_empty2">去预约</div>
      </div>
    </div>



  </div>
</template>

<script>
  export default {
    data() {
      return {
        order_title:[
          {name:'全部',status:0},
          {name:'待使用',status:1},
          {name:'已退订',status:2},
          {name:'已完成',status:3},
        ],
        status: {
          "1": "待使用",
          "2": "已退订",
          "3": "已完成",

        },
        order_title_status:0,
        orderList:[],
        page:1,
        pageSize:20,
        pageType:0,
        loaded:false,


        loading:true,
        finished:false

      }
    },
    created() { },
    mounted() { },
    activated() {
      // sessionStorage.setItem('order_detail_unchange','yes')
      if(sessionStorage.getItem('order_detail_unchange')=='yes'){
        sessionStorage.removeItem('order_detail_unchange')
      }else{
        this.page=1
        this.orderList=[]
        this.loaded=false
        if(sessionStorage.getItem('order_list_status')){
          this.pageType=sessionStorage.getItem('order_list_status')
          this.order_title_status=sessionStorage.getItem('order_list_status')
          sessionStorage.removeItem('order_list_status')
          this.getOrderList()
        }else{
          this.getOrderList()
        }
      }

    },
    methods: {
      toorder(){
        sessionStorage.setItem('listRadio','0')
        this.$router.push({
          name:'reserve'
        })
      },
      getOrderList(){
        var $this = this
        this.loading=true
        let param = {
          token: localStorage.getItem("token"),
          page: this.page,
          limit: this.pageSize,
          status: this.pageType,
          type:this.pageType,
        }
        var qs = require('qs');
        let url = this.api.userApi.bookOrderList
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(param.page)
          // console.log(result)
          // result.data.data=[]
          setTimeout(function(){
            if (result.code == 0) {
              $this.loading=false
              if(result.data.data.length<$this.pageSize){
                $this.finished=true
              }
              if(result.data.data.length>0){
                if($this.orderList.length==0){
                  $this.orderList=result.data.data
                  // console.log('替换')
                }else{
                  $this.orderList=$this.orderList.concat(result.data.data)
                  // console.log('拼接')
                }
              }else{
                // $this.orderList=[]
              }
              $this.loaded=true
            } else {
              $this.loading=false
              $this.$toast(result.msg)
            }
          },100);

        }).catch((error) => {
          console.warn(error)
        })
      },
      onLoad(){
        // this.loading=true
        this.loading=false
        this.page++
        this.getOrderList()
      },
      selectOrderStatus(item){
        // console.log(item)
        this.page=1
        this.loaded=false
        this.finished=false
        this.orderList=[]
        this.order_title_status=item.status
        this.pageType=item.status
        this.getOrderList()
      },
      showOrderDetail(item){
        // console.log(item)
        var param={
          order_no:item.order_no,
          book_type:item.type
        }
        this.$router.push({
          name:'orderdetail',
          params:param
        })
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .head_title{
    display: inline-block;
    width: 25%;
    height: 90*@vm_base;
    font-size: 32*@vm_base;
    line-height: 90*@vm_base;
    text-align: center;
  }
  .head_title_active{
    color: #444054;
    font-weight: 600;
  }
  .head_title_unactive{
    color: #B4B3BB;
    font-weight: 400;
  }
  .order_list{
    width: 100%;
    padding: 40*@vm_base 32*@vm_base 0*@vm_base 32*@vm_base;
    .order_list_block{
      position: relative;
      width: 100%;
      background: #FFFFFF;
      box-shadow: 0px 0px 20*@vm_base 0px #EEEEEE;
      border-radius: 12*@vm_base;
      padding: 16*@vm_base 32*@vm_base 0 32*@vm_base;
      margin-bottom: 40*@vm_base;
      .title{
        width: 100%;
        padding: 28*@vm_base 0;
        font-size: 28*@vm_base;
        font-weight: 500;
        color: #8F8C98;
        border-bottom: 1*@vm_base solid #EBEBEB;
        .title_status{
          float: right;padding-right: 20*@vm_base;
          background-image: url(../../assets/images/base/orderArrow.png);
          background-size: 12*@vm_base auto;
          background-position: center right;
          background-repeat: no-repeat;
          color: #8F8C98;
        }
        .title_arrowUnuse{
          color: #0091FF;
        }
      }
      .cont{
        padding: 16*@vm_base 0 56*@vm_base 0;
        .cont_stadium_name{
          padding: 16*@vm_base 0;
          width: 100%;
          font-size: 36*@vm_base;
          font-weight: 500;
          color: #8F8C98;
        }
        .cont_stadium_nameUnuse{
          color: #444054;
        }
        .cont_date{
          padding: 16*@vm_base 0;
          width: 100%;
          font-size: 28*@vm_base;
          font-weight: 500;
          color: #8F8C98;
        }
        .cont_num{
          padding: 4*@vm_base 0;
          width: 100%;
          font-size: 28*@vm_base;
          font-weight: 500;
          color: #8F8C98;
        }
      }
      .logo_yoga{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 109*@vm_base;
      }
      .logo_fit{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 81*@vm_base;
      }
    }
    .order_list_empty{
      width: 100%;
      img{
        width: 40%;
        margin: 50*@vm_base auto 30*@vm_base auto;
      }
      .order_list_empty1{
        width: 100%;
        text-align: center;
        font-size: 32*@vm_base;
        color: #666666;
      }
      .order_list_empty2{
        // display: inline-block;
        width: 350*@vm_base;
        margin-left: calc(50% - 175*@vm_base);
        font-size: 32*@vm_base;
        font-weight: 500;
        color: #444054;
        text-align: center;
        line-height: 1.125;
        padding: 25*@vm_base 0;
        border-radius: 45*@vm_base;
        border: 2*@vm_base solid #DDDDDD;
        margin: 0 auto;
        margin-top: 40*@vm_base;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/order/list.vue